export function BindPressRelease(size, page) {
  // clean list and pagination
  $('#NewsList').html('');
  $('.press-releases-pagination-js').html('');
  $('.mck-press-releases-loading-js').show();

  let Topic = 0;
  let Industry = 0;
  let Business = 0;
  let Month = 0;

  try {
    Topic = $('#SelectedTopic option:selected').val();
    Industry = $('#SelectedIndustry option:selected').val();
    Business = $('#SelectedBusiness option:selected').val();
    Month = $('#SelectedDate option:selected').val();
  } catch (err) {
    (Topic = 0), (Industry = 0), (Business = 0), (Month = 0);
    }
    var filtersarray=[];
    $('select').each(function () {   
        var x = {ParentID : this.id , SelectedID : $(this).children("option").filter(":selected").val() };
        filtersarray.push(x);       
    })
    
  let PRFolderId =
    $('#hdnPRFolderId').length > 0 ? $('#hdnPRFolderId').val() : undefined;
  let resultArray = PRFolderId ? PRFolderId.split(',').map(Number) : undefined;

  try {
    void 0 === Topic && (Topic = 0),
      void 0 === Business && (Business = 0),
      void 0 === Industry && (Industry = 0),
      void 0 === Month && (Month = 0),
      void 0 === size && (size = 25);
  } catch (ex) {}

  const requestData = JSON.stringify({
    lngFolderID: resultArray,
    lngTopic: Topic,
    lngBusiness: Business,
    lngIndustry: Industry,
    strMonth: Month,
    intSize: size,
    intPage: page,
    filtersarrayproperty:JSON.stringify(filtersarray)
  });

    $.ajax({
        type: 'POST',
        url: 'pressreleasebind',
        data: requestData,
    contentType: 'application/json; charset=utf-8',
    dataType: 'html',
    success: function (response) {
      $('.mck-press-releases-loading-js').hide();
      try {
        let splitText = response.split(
          '<div id="divPagination" class="press-releases-pagination-js">',
        );
        const $newsList = $('#NewsList');

        if ('' !== splitText[0] && String(splitText[0]).includes('article')) {
          $newsList.html(splitText[0]);
          $('.press-releases-pagination-js').html(splitText[1]);
        } else {
          $newsList.css('display', 'none');
          $newsList.html(splitText[0]);
          let message,
            month = $('#SelectedDate option:selected'),
            topic = $('#SelectedTopic option:selected'),
            industry = $('#SelectedIndustry option:selected'),
            business = $('#SelectedBusiness option:selected');

          const noResultsText = [
            '<strong>Sorry!</strong> No ',
            month.val() != 0 ? `${month.text()} ` : '',
            topic.val() != 0 ? `${topic.text()} ` : '',
            industry.val() != 0 ? `${industry.text()} ` : '',
            business.val() != 0 ? `${business.text()} ` : '',
            'are available.',
          ];

          $newsList.html(noResultsText.join(''));
          $newsList.removeAttr('style');

          // message comes from <head><meta> on live site
          message =
            '0' == month.val() &&
            '0' == topic.val() &&
            '0' == industry.val() &&
            '0' == business.val()
              ? $("meta[name='No Results Message']").attr('content')
              : $("meta[name='No Results Message Filtered']").attr('content');

          (message =
            '0' != month.val() && month.val()
              ? message.replace('[Month ]', month.text() + ' ')
              : message.replace('[Month ]', '')),
            (message =
              '0' != topic.val() && topic.val()
                ? message.replace('[Topic ]', topic.text() + ' ')
                : message.replace('[Topic ]', '')),
            (message =
              '0' != industry.val() && industry.val()
                ? message.replace(
                    '[for Industry ]',
                    'for ' + industry.text() + ' ',
                  )
                : message.replace('[for Industry ]', '')),
            (message =
              '0' != business.val() && business.val()
                ? message.replace(
                    '[from Business Unit ]',
                    'from ' + business.text() + ' ',
                  )
                : message.replace('[from Business Unit ]', '')),
            (message = '<p>' + message + '</p>'),
            $newsList.html(message),
            $newsList.removeAttr('style');
        }

        SetPushState({
          topic: Topic,
          business: Business,
          industry: Industry,
          month: Month,
          page: page,
        });

        $('html, body').animate(
          {
            scrollTop: 0,
          },
          0,
        );
      } catch (ex) {}
    },
    failure: function (response) {
      $('.mck-press-releases-loading-js').hide();
      alert(response);
    },
    error: function (jqXHR, textStatus, errorThrown) {
      if (!jqXHR || !Boolean(jqXHR.responseText)) {
        return;
      }

      showResponseErrorMessage(jqXHR);
    },
  });
}

export function ResetReleasesFilters() {
  $('#NewsList').html('');
  $('.press-releases-pagination-js').html('');
  $('.mck-press-releases-loading-js').show();

  const $filtersSelects = $('.filters select');
  const $prettySelects = $('.pretty-select');
  const pageSize = $('#hdnPageSize').val();

  $filtersSelects.unbind('change');
  $prettySelects.each(function () {
    $(this).val($(this).find('option:first-child').val());
    $(this).trigger('change');
  });

  $prettySelects.select2({
    minimumResultsForSearch: 1 / 0,
  });

  $('.filter-sets select').on('change', function () {
    let defaultFilters = !0;
    $prettySelects.each(function () {
      $(this).find('option:first-child').val() !== $(this).select2('val') &&
        (defaultFilters = !1);
    });
    defaultFilters
      ? $('.reset.active').removeClass('active')
      : $('.reset').addClass('active');
  });

  $filtersSelects.change(function () {
    BindPressRelease(pageSize, 1);
  });

  // history.pushState('', '', '?');

  let Topic = '0',
    Industry = '0',
    Business = '0',
    Month = '',
    PRFolderId =
      $('#hdnPRFolderId').length > 0 ? $('#hdnPRFolderId').val() : undefined,
    resultArray = PRFolderId ? PRFolderId.split(',').map(Number) : undefined;

  const requestData = JSON.stringify({
    lngFolderID: resultArray,
    lngTopic: Topic,
    lngBusiness: Business,
    lngIndustry: Industry,
    strMonth: Month,
    intSize: pageSize || 25,
    intPage: 1,
  });

  $.ajax({
    type: 'POST',
    url: 'pressreleasebind',
    data: requestData,
    contentType: 'application/json; charset=utf-8',
    dataType: 'html',
    success: function (response) {
      $('.mck-press-releases-loading-js').hide();
      try {
        let splitText = response.split(
          '<div id="divPagination" class="press-releases-pagination-js">',
        );
        $('#NewsList').html(splitText[0]);
        $('.press-releases-pagination-js').html(splitText[1]);
        SetPushState({
          topic: Topic,
          business: Business,
          industry: Industry,
          month: Month,
        }),
          $('html, body').animate(
            {
              scrollTop: 0,
            },
            0,
          );
      } catch (ex) {}
    },
    failure: function (response) {
      $('.mck-press-releases-loading-js').hide();
      alert(response);
    },
    error: function (jqXHR, textStatus, errorThrown) {
      showResponseErrorMessage(jqXHR);
    },
  });
}

function showResponseErrorMessage(jqXHR) {
  let errMessage = 'An error occurred serving your request. Please try again.';
  let parsedJson;

  try {
    parsedJson = $.parseJSON(jqXHR.responseText).Message;
    errMessage = parsedJson;
  } catch (e) {
    console.log('wrong response data');
  }
  $('.mck-press-releases-loading-js').hide();
  alert(errMessage);
}

window.BindPressRelease = BindPressRelease;
window.ResetReleasesFilters = ResetReleasesFilters;
